module.exports = __webpack_public_path__ + "img/852593fb4a53375511db30182902e0d8.852593fb.png";